/**
 * @fileoverview QuicksearchFooter — "Hotkeys" footer row showing key
 * combos and their labels. Pass an array of `{ keys, label }` entries.
 * Foundry mapping: `quicksearch-dialog__footer__1ja3fz5` +
 * `quicksearch-shared-components__combo__1thxe08`.
 */

import { Fragment, type ReactElement } from "react";

export interface HotkeyEntry {
  /** Sequential keys, e.g. ["ctrl", "J"]. */
  keys: ReadonlyArray<string>;
  label: string;
}

interface QuicksearchFooterProps {
  hotkeys: ReadonlyArray<HotkeyEntry>;
  className?: string;
}

export function QuicksearchFooter({
  hotkeys,
  className,
}: QuicksearchFooterProps): ReactElement {
  return (
    <div data-testid="quicksearch-footer" className={["bp-quicksearch-footer-bar", className].filter(Boolean).join(" ")}>
      <div className="bp-quicksearch-hotkeys-label">Hotkeys</div>
      {hotkeys.map((h, i) => (
        <div key={i} className="bp-quicksearch-hotkey">
          <span className="bp-quicksearch-combo">
            {h.keys.map((k, j) => (
              <Fragment key={j}>
                <span className="bp6-key-combo bp6-minimal">{k}</span>
                {j < h.keys.length - 1 && <span>+</span>}
              </Fragment>
            ))}
          </span>
          <span className="bp-quicksearch-hotkey-label">{h.label}</span>
        </div>
      ))}
    </div>
  );
}
